import $ from "jquery"
import _ from "underscore"
import OverlayTips from "../OverlayTips";
import PageOverlayTipsManager from "../PageOverlayTipsManager"

function LeaveTypesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

LeaveTypesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pageTitleWithSharedSettingsImage"), {
            messageKey: "tips.leave_types.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetY: 0
            }
        });
    },

    addTableTips: function(ptoEnabled, sickEnabled)
    {
        this.deferUntilEnabled(function()
                               {
                                   this.add(function() { return $("td.leaveTypeImageCell").eqOrLast(5)}, {
                                       messageKey: "tips.leave_types.icon",
                                       direction: OverlayTips.DIRECTION_TOP_LEFT,
                                       offsetX: -20,
                                       offsetY: -10,
                                       outside: {
                                           direction: OverlayTips.DIRECTION_TOP_RIGHT
                                       }
                                   });

                                   this.add(function() { return $("td.leaveTypeNameCell").eqOrLast(4)}, {
                                       messageKey: "tips.leave_types.edit",
                                       direction: OverlayTips.DIRECTION_TOP_RIGHT,
                                       offsetX: -100
                                   });

                                   var leaveTypeAffectedBalanceTipMessageKey = null;
                                   if (ptoEnabled && sickEnabled)
                                   {
                                       leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.pto_sick_days";
                                   }
                                   else if (ptoEnabled)
                                   {
                                       leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.pto";
                                   }
                                   else if (sickEnabled)
                                   {
                                       leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.sick";
                                   }

                                   if (leaveTypeAffectedBalanceTipMessageKey != null)
                                   {
                                       this.add(function() { return $("td.leaveTypeAffectedBalanceCell").eqOrLast(1)}, {
                                           messageKey: leaveTypeAffectedBalanceTipMessageKey,
                                           direction: OverlayTips.DIRECTION_TOP_RIGHT,
                                           offsetX: -40
                                       });
                                   }
                               });
    }
});

export default LeaveTypesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/LeaveTypesPageOverlayTipsManager.js